/**
 * 部门模块 - 常量定义
 * 
 * @module types/department/constants
 * @description 部门管理模块的常量定义（映射、标签等）
 * 
 * 对应后端文件:
 * - backend/app/Models/Department.php (静态属性)
 * 
 * 注意事项:
 * - 常量名使用 UPPER_SNAKE_CASE
 * - 用于前端显示的中文标签映射
 * 
 * 更新时机:
 * - 后端修改 Model 的静态属性时
 * - 枚举值对应的中文标签变更时
 * 
 * @last-updated 2025-10-18
 */

import { DepartmentStatus } from './enums';

/**
 * 部门状态标签映射
 * 
 * 对应后端: Department::$statusMap
 */
export const DEPARTMENT_STATUS_LABELS: Record<DepartmentStatus, string> = {
  [DepartmentStatus.ENABLED]: '启用',
  [DepartmentStatus.DISABLED]: '禁用',
};

/**
 * 部门状态选项（用于下拉选择）
 */
export const DEPARTMENT_STATUS_OPTIONS = [
  { label: '启用', value: DepartmentStatus.ENABLED },
  { label: '禁用', value: DepartmentStatus.DISABLED },
];

